import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight',
    pure: true,
    standalone: false,
})
export class HighlightPipe implements PipeTransform {
    transform(text: string, search): string {
        let pattern = search?.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
        pattern = pattern
            ?.split(' ')
            ?.filter(t => {
                return t?.length > 0;
            })
            ?.join('|');
        const regex = new RegExp(pattern, 'gi');

        return search ? text?.replace(regex, match => `<span class="highlightSuggestedOption">${match}</span>`) : text;
    }
}

// https://stackoverflow.com/questions/44961759/highlight-the-search-text-angular-2
// https://gist.github.com/adamrecsko/0f28f474eca63e0279455476cc11eca7#gistcomment-2554394
